import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationIsActive,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for ethnic group data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listEthnicGroups(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode
        name
        details

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for ethnic group data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertEthnicGroup(
        input: {
          ${getMutationStringValue(doc, 'id')}

          ${getMutationStringValue(doc, 'name')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize ethnic group data with GraphQL endpoint
 */
export const syncEthnicGroup = (...args) => {
  return buildReplication(
    ...args,
    'ethnicGroup',
    { pullBuilder, pullQuery: 'listEthnicGroups' },
    { pushBuilder }
  );
};
